import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXlsx = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7.5L14.5 2Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 2V8H20",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.56 16L7.76 14.755H7.75L6.95 16H6.13L7.29 14.215L6.165 12.45H6.97L7.75 13.675H7.76L8.54 12.45H9.345L8.22 14.215L9.38 16H8.56ZM9.69748 16V12.45H10.4025V15.375H11.9825V16H9.69748ZM13.3963 16.04C12.8929 16.04 12.4613 15.8533 12.1013 15.48L12.5213 14.96C12.6479 15.1067 12.7896 15.2183 12.9463 15.295C13.1029 15.3683 13.2563 15.405 13.4063 15.405C13.5729 15.405 13.6996 15.3717 13.7863 15.305C13.8729 15.235 13.9163 15.1433 13.9163 15.03C13.9163 14.9067 13.8713 14.8133 13.7813 14.75C13.6913 14.6833 13.5296 14.61 13.2963 14.53C13.1363 14.4733 13.0029 14.42 12.8963 14.37C12.7896 14.3167 12.6796 14.2467 12.5663 14.16C12.4529 14.0733 12.3679 13.9683 12.3113 13.845C12.2546 13.7217 12.2263 13.58 12.2263 13.42C12.2263 13.1367 12.3363 12.8983 12.5563 12.705C12.7763 12.5117 13.0463 12.4117 13.3663 12.405C13.7996 12.4017 14.1979 12.5517 14.5613 12.855L14.1563 13.385C13.8763 13.1517 13.6179 13.035 13.3813 13.035C13.2546 13.035 13.1513 13.0667 13.0713 13.13C12.9946 13.1933 12.9563 13.28 12.9563 13.39C12.9529 13.4933 12.9946 13.5767 13.0813 13.64C13.1679 13.7 13.3246 13.775 13.5513 13.865C13.9179 14.0083 14.1579 14.1183 14.2713 14.195C14.5246 14.3683 14.6513 14.62 14.6513 14.95C14.6513 15.3067 14.5246 15.5783 14.2713 15.765C14.0179 15.9483 13.7263 16.04 13.3963 16.04ZM17.1494 16L16.3494 14.755H16.3394L15.5394 16H14.7194L15.8794 14.215L14.7544 12.45H15.5594L16.3394 13.675H16.3494L17.1294 12.45H17.9344L16.8094 14.215L17.9694 16H17.1494Z",
			fill: "currentColor"
		})
	]
});
export default SvgXlsx;
